import { type OptionToken } from '../../../core/themeToken';

export function getLineColor(seriesLen: number, seriesIndex: number, optionToken: OptionToken) {
  const LineSeriesColorLen = optionToken.line.seriesColor.length;
  const idx = seriesIndex % LineSeriesColorLen;
  if (seriesIndex === seriesLen - 1 && seriesLen > 1) {
    return optionToken.line.seriesColor[LineSeriesColorLen - 1];
  }
  return optionToken.line.seriesColor[idx];
}

export function getBarColor(seriesIndex: number, isSingleBar = false, optionToken: OptionToken) {
  if (isSingleBar) {
    return optionToken.bar.seriesColor[0];
  }
  const BarSeriesColorLen = optionToken.bar.seriesColor.length;
  const idx = seriesIndex % BarSeriesColorLen;
  return optionToken.bar.seriesColor[idx];
}
